// CUSTODY v2 — the section's router (his custody redesign, yes on 2 Nov 2026: four screens instead of seven). Drawn only when
// lib/ui-v2.ts switches batch 4 on AND CUSTODY_IN_CONSOLE is true (App.tsx); otherwise /custody is today's v1 section.
//
//   /custody                      Waiting on you            /custody/approvals/:txid   a card's review and signing
//   /custody/deposits             Deposits & addresses      /custody/deposits/:id      the same, one deposit opened
//   /custody/deposits/new         issue a deposit address   /custody/wallets           Wallets (+ payout addresses)
//   /custody/settings             Settings (+ keys)         /custody/pay/:entryId · /custody/move · /custody/refill
//   /custody/wallets/propose      propose a payout address  /custody/settings/register  register a signing device
//
// Every older path lands on its screen: balances → wallets, addresses → deposits?show=addresses, whitelist → wallets, keys
// and flow → settings, the approvals list → Waiting on you.
import { Navigate, Route, Routes } from 'react-router-dom';
import { CustodySigninShell } from '../../../components/v2/custody/SigninLine';
import { CustodyOverviewV2 } from './Overview';
import { ApprovalsHostV2, ApprovalReviewV2 } from './Approvals';
import { DepositsV2 } from './Deposits';
import { WalletsCustodyV2 } from './Wallets';
import { CustodySettingsScreenV2 } from './Settings';
import { IssueAddressV2 } from '../custody-admin/IssueAddress';
import { ProposeAddressV2 } from '../custody-admin/ProposeAddress';
import { RegisterKeyV2 } from '../custody-admin/RegisterKey';
import { PayV2, PayChooseV2, MoveToTreasuryV2, RefillV2, FlaggedToHotV2 } from './MovePages';

export function CustodyV2() {
  return (
    // The lapsed custody sign-in: one line above every custody screen, nothing unmounted (2 Nov 2026).
    <CustodySigninShell>
    <Routes>
      {/* ONE APPROVAL CONTROLLER ABOVE EVERY CUSTODY SCREEN (Astra, 2 Nov 2026): the second device's approval (Approvals.tsx
          useCardApproval, the wallet's) lives in this host, so leaving a review for Waiting on you and coming back keeps its
          busy guard and any unknown outcome — a card is never approved twice. */}
      <Route element={<ApprovalsHostV2 />}>
        <Route index element={<CustodyOverviewV2 />} />
        <Route path="deposits" element={<DepositsV2 />} />
        <Route path="deposits/new" element={<IssueAddressV2 />} />
        <Route path="deposits/:id" element={<DepositsV2 />} />
        <Route path="wallets" element={<WalletsCustodyV2 />} />
        <Route path="wallets/propose" element={<ProposeAddressV2 />} />
        <Route path="settings" element={<CustodySettingsScreenV2 />} />
        <Route path="settings/register" element={<RegisterKeyV2 />} />
        {/* Older paths land on the screen that holds them now. */}
        <Route path="balances" element={<Navigate to="/custody/wallets" replace />} />
        <Route path="whitelist" element={<Navigate to="/custody/wallets#payouts" replace />} />
        <Route path="addresses" element={<Navigate to="/custody/deposits?show=addresses" replace />} />
        <Route path="keys" element={<Navigate to="/custody/settings" replace />} />
        <Route path="flow" element={<Navigate to="/custody" replace />} />
        {/* The list is Waiting on you; a card's review keeps its own path. */}
        <Route path="approvals" element={<Navigate to="/custody" replace />} />
        <Route path="approvals/:txid" element={<ApprovalReviewV2 />} />
        <Route path="pay" element={<PayChooseV2 />} />
        <Route path="pay/:entryId" element={<PayV2 />} />
        <Route path="move" element={<MoveToTreasuryV2 />} />
        <Route path="refill" element={<RefillV2 />} />
        <Route path="return" element={<FlaggedToHotV2 />} />
        <Route path="*" element={<Navigate to="/custody" replace />} />
      </Route>
    </Routes>
    </CustodySigninShell>
  );
}
